import { defaultIsExternalLink } from '@cigna/cigna_csg_gsg_cipublic-link/lib/interfaces.js';
//
// Feel free to add and export more utils as needed for other sites
//
let allEligibleEls;
export const formatProductString = ({ impressionVariable, impressionType, impressionEventType, slots }) => `;${impressionType};;;;${impressionVariable}=${impressionEventType}^${slots.join('^')}`;
export const getCleanPathname = (pathname) => pathname.replace(/^\/|\/$/g, '') || 'index';
export const addToSetIfTruthy = (setObj, value) => {
    if (value)
        setObj.add(value);
};
export const getParentElement = (path, checkForImpression = false) => {
    allEligibleEls = Array.from(path).filter((element) => element instanceof HTMLElement && element.tagName.includes('CIPUBLIC'));
    let endOfPath;
    if (allEligibleEls.length > 1)
        endOfPath = allEligibleEls.slice(-1)[0];
    else
        endOfPath = 'body';
    if (endOfPath instanceof HTMLElement) {
        return checkForImpression ? endOfPath.getAttribute('data-impression') : endOfPath.tagName.toLowerCase();
    }
    else
        return endOfPath;
};
export const getImpressionParentElement = (path, checkForImpression = false) => {
    allEligibleEls = Array.from(path).filter((element) => element instanceof HTMLElement && element.tagName.includes('CIPUBLIC'));
    let endOfPath;
    if (allEligibleEls.length > 1)
        endOfPath = allEligibleEls.find((e) => e.hasAttribute('data-impression'));
    else
        endOfPath = 'body';
    if (endOfPath instanceof HTMLElement) {
        return checkForImpression ? endOfPath.getAttribute('data-impression') : endOfPath.tagName.toLowerCase();
    }
    else
        return endOfPath;
};
export const getElementHeader = () => {
    var _a;
    if (allEligibleEls.length > 1) {
        const headerSelector = ['H1', 'H2', 'H3', 'H4', 'H5', 'H6', 'HEADER'];
        let componentHeader = allEligibleEls.find((el) => Array.from(el.children).find((child) => child.getAttribute('slot') === 'heading' || headerSelector.includes(child.tagName)));
        if (componentHeader) {
            componentHeader = Array.from(componentHeader.children).find((child) => child.getAttribute('slot') === 'heading' || headerSelector.includes(child.tagName));
        }
        if (componentHeader && componentHeader.innerText.length)
            return (_a = componentHeader.innerText) === null || _a === void 0 ? void 0 : _a.trim();
        else
            return '';
    }
    else
        return '';
};
export const getElementText = (element) => {
    var _a;
    let text = (_a = element.innerText) === null || _a === void 0 ? void 0 : _a.trim();
    if (!text) {
        const img = element === null || element === void 0 ? void 0 : element.querySelector('cipublic-image');
        if (img)
            text = img.getAttribute('alt') || img.getAttribute('title') || img.getAttribute('aria-label') || '';
    }
    if (element.hasAttribute('data-en-content'))
        return element.getAttribute('data-en-content') || '';
    return text || element.getAttribute('value') || element.getAttribute('title') || element.getAttribute('aria-label') || '';
};
export const getElDownloadExitLink = (link, suffix = false) => {
    var _a;
    if (link.href) {
        const isExternalLink = (link) => {
            const url = new URL(link || '', location.origin);
            if (defaultIsExternalLink(url)) {
                return true;
            }
            else {
                return false;
            }
        };
        if (['.pdf', '.zip'].some((ext) => link.href.includes(ext))) {
            return suffix ? (_a = ['.pdf', '.zip'].find((ext) => link.href.includes(ext))) === null || _a === void 0 ? void 0 : _a.replace('.', '-') : `download:${link.href}`;
        }
        else if (isExternalLink(link.href)) {
            return suffix ? '-exit' : `exit:${link.href}`;
        }
        else {
            return '';
        }
    }
    else {
        return '';
    }
};
let counter = 0;
export const sendAnalytics = (ruleName, products, digitalActions = {}, customObj = {}) => {
    const { digitalData, _satellite } = window;
    if (digitalData && typeof digitalData.actions.item !== 'undefined' && _satellite && _satellite.track) {
        if (Object.prototype.hasOwnProperty.call(digitalActions, 'item')) {
            digitalData.actions = digitalActions;
        }
        _satellite.track(ruleName, { products, ...customObj });
    }
    else {
        counter += 1;
        if (counter < 25)
            setTimeout(() => sendAnalytics(ruleName, products, digitalActions, customObj), 200);
        else
            return;
    }
};
export const queryShadowRoot = (root, skipNode, isMatch, maxDepth = 600, depth = 0) => {
    const matches = [];
    if (depth >= maxDepth || (root instanceof HTMLElement && skipNode(root))) {
        return matches;
    }
    const traverseSlot = ($slot) => {
        const assignedNodes = $slot.assignedNodes().filter((node) => node.nodeType === 1);
        if (assignedNodes.length > 0) {
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const $slotParent = assignedNodes[0].parentElement;
            if ($slotParent.hasAttribute('data-impression')) {
                const visibleAssignedNode = assignedNodes.filter((element) => element.getAttribute('tabindex') !== '-1');
                return queryShadowRoot(visibleAssignedNode[0], skipNode, isMatch, maxDepth, depth + 1);
            }
            return queryShadowRoot($slotParent, skipNode, isMatch, maxDepth, depth + 1);
        }
        return [];
    };
    let children;
    if (root.shadowRoot != null) {
        children = Array.from(root.shadowRoot.children || []);
    }
    else {
        children = Array.from(root.children || []);
    }
    if (root.tagName && root.tagName.includes('CIPUBLIC') && children.length === 0) {
        children.push(root);
    }
    for (const $child of children) {
        if (skipNode($child) && !$child.tagName.includes('CIPUBLIC')) {
            continue;
        }
        if (isMatch($child)) {
            matches.push($child);
            break;
        }
        if (!skipNode($child)) {
            if ($child.shadowRoot != null) {
                matches.push(...queryShadowRoot($child.shadowRoot, skipNode, isMatch, maxDepth, depth + 1));
            }
            else if ($child.tagName === 'SLOT') {
                matches.push(...traverseSlot($child));
            }
            else {
                matches.push(...queryShadowRoot($child, skipNode, isMatch, maxDepth, depth + 1));
            }
        }
    }
    const filteredMatches = matches.filter((c, index) => matches.indexOf(c) === index);
    return filteredMatches;
};
export const customTagEvent = (thisEl, target) => {
    thisEl.dispatchEvent(new CustomEvent('custom-tag-event', { bubbles: true, composed: true, cancelable: true, detail: target }));
};
//# sourceMappingURL=utils.js.map